import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import _createForOfIteratorHelper from "@babel/runtime/helpers/createForOfIteratorHelper";
import _regeneratorRuntime from "@babel/runtime/regenerator";
import { ensureScriptWrapper, HTML_ATTRIBUTE_CAPTURE_PREFIX, HTML_ATTRIBUTE_CAPTURE_CLICK_PREFIX, HTML_ATTRIBUTE_CAPTURE_SUFFIX, HTML_ATTRIBUTE_BLOCKER_CONNECTED } from ".";
import { OPT_IN_CONTENT_BLOCKER_ALL } from "../events";
import { findVisualParent } from "../visual";
var tagTransformationCounter = 0;
var HTML_TAG_TRANSFORMATION_COUNTER = "consent-tag-transformation-counter";
/**
 * Transform e. g. `consent-original-href` to `href` of a given node.
 */

function transformToOriginalAttribute(_ref) {
  var node = _ref.node,
      allowClickOverrides = _ref.allowClickOverrides,
      onlyModifyAttributes = _ref.onlyModifyAttributes,
      setVisualParentIfClassOfParent = _ref.setVisualParentIfClassOfParent,
      overwriteAttributeValue = _ref.overwriteAttributeValue;
  return new Promise(function (resolve) {
    var performedClick = false; // Scripts need to be handled differently cause we want to use `postscribe` and should not be attached
    // to the DOM -> not be executed

    var tagName = node.tagName.toLowerCase();
    var isScript = tagName === "script";
    var workWithNode = isScript && !onlyModifyAttributes ? node.cloneNode(true) : node; // Do the transformation from "blocked" state to "unblocked"

    var _iterator = _createForOfIteratorHelper(workWithNode.getAttributeNames()),
        _step;

    try {
      for (_iterator.s(); !(_step = _iterator.n()).done;) {
        var attribute = _step.value;

        if (attribute.startsWith(HTML_ATTRIBUTE_CAPTURE_PREFIX) && attribute.endsWith(HTML_ATTRIBUTE_CAPTURE_SUFFIX)) {
          var _workWithNode$getAttr;

          var _originalAttribute = attribute.substr(HTML_ATTRIBUTE_CAPTURE_PREFIX.length + 1);

          _originalAttribute = _originalAttribute.slice(0, (HTML_ATTRIBUTE_CAPTURE_SUFFIX.length + 1) * -1); // Check if `allowClickOverride` is given and then the `consent-click-original` attribute may be used, if given

          var overwriteClickAttribute = "".concat(HTML_ATTRIBUTE_CAPTURE_CLICK_PREFIX, "-").concat(_originalAttribute, "-").concat(HTML_ATTRIBUTE_CAPTURE_SUFFIX);
          var hasOverwriteClickAttribute = workWithNode.hasAttribute(overwriteClickAttribute) && allowClickOverrides;

          var _value = workWithNode.getAttribute(hasOverwriteClickAttribute ? overwriteClickAttribute : attribute);

          if (hasOverwriteClickAttribute) {
            performedClick = true;
          }

          if (overwriteAttributeValue) {
            _value = overwriteAttributeValue(_value, _originalAttribute);
          } // Finally, set the valid values


          workWithNode.setAttribute(_originalAttribute, _value);
          workWithNode.removeAttribute(attribute);
          workWithNode.removeAttribute(overwriteClickAttribute); // Automatically delegate a `click` event

          if (allowClickOverrides && ["a"].indexOf(tagName) > -1 && (["onclick"].indexOf(_originalAttribute.toLowerCase()) > -1 || (_workWithNode$getAttr = workWithNode.getAttribute("href")) !== null && _workWithNode$getAttr !== void 0 && _workWithNode$getAttr.startsWith("#"))) {
            workWithNode.addEventListener(OPT_IN_CONTENT_BLOCKER_ALL, /*#__PURE__*/function () {
              var _ref3 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(_ref2) {
                var unblockedNodes;
                return _regeneratorRuntime.wrap(function _callee$(_context) {
                  while (1) {
                    switch (_context.prev = _context.next) {
                      case 0:
                        unblockedNodes = _ref2.detail.unblockedNodes;
                        return _context.abrupt("return", unblockedNodes.forEach(function () {
                          return workWithNode.click();
                        }));

                      case 2:
                      case "end":
                        return _context.stop();
                    }
                  }
                }, _callee);
              }));

              return function (_x) {
                return _ref3.apply(this, arguments);
              };
            }());
          }
        }
      } // Are there any non-transformed clicked attributes? E.g. only add an attribute when it got clicked (without original attribute)

    } catch (err) {
      _iterator.e(err);
    } finally {
      _iterator.f();
    }

    var _iterator2 = _createForOfIteratorHelper(workWithNode.getAttributeNames()),
        _step2;

    try {
      for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
        var _attribute = _step2.value;

        if (_attribute.startsWith(HTML_ATTRIBUTE_CAPTURE_CLICK_PREFIX) && _attribute.endsWith(HTML_ATTRIBUTE_CAPTURE_SUFFIX)) {
          var _value2 = workWithNode.getAttribute(_attribute);

          var _originalAttribute2 = _attribute.substr(HTML_ATTRIBUTE_CAPTURE_CLICK_PREFIX.length + 1);

          _originalAttribute2 = _originalAttribute2.slice(0, (HTML_ATTRIBUTE_CAPTURE_SUFFIX.length + 1) * -1); // Finally, set the valid values

          if (allowClickOverrides) {
            workWithNode.setAttribute(_originalAttribute2, _value2);
            performedClick = true;
          }

          workWithNode.removeAttribute(_attribute);
        }
      }
    } catch (err) {
      _iterator2.e(err);
    } finally {
      _iterator2.f();
    }

    var result = {
      performedClick: performedClick,
      workWithNode: node
    };

    if (onlyModifyAttributes) {
      result.performedClick = false;
      resolve(result);
      return;
    } // Allow transition of custom element tags (web components).
    // See also https://html.spec.whatwg.org/multipage/custom-elements.html#custom-elements-customized-builtin-example)


    if (tagName.startsWith("consent-") && customElements) {
      var originalTag = tagName.substring(8);
      workWithNode.outerHTML = workWithNode.outerHTML.replace(/^<consent-[^\s]+/m, "<".concat(originalTag, " ").concat(HTML_TAG_TRANSFORMATION_COUNTER, "=\"").concat(tagTransformationCounter, "\"")).replace(/<\/consent-[^\s]+>$/m, "</".concat(originalTag, ">"));
      workWithNode = document.querySelector("[".concat(HTML_TAG_TRANSFORMATION_COUNTER, "=\"").concat(tagTransformationCounter, "\"]"));
      tagTransformationCounter++;
      result.workWithNode = workWithNode;
    }

    workWithNode.style.removeProperty("display"); // Also make the parent visual visible again

    var _findVisualParent = findVisualParent(node, setVisualParentIfClassOfParent || {}),
        _findVisualParent2 = _slicedToArray(_findVisualParent, 1),
        visualParent = _findVisualParent2[0];

    if (visualParent !== node || visualParent !== null && visualParent !== void 0 && visualParent.hasAttribute(HTML_ATTRIBUTE_BLOCKER_CONNECTED)) {
      visualParent.style.removeProperty("display");
    }

    if (!isScript) {
      resolve(result);
    } else {
      var _workWithNode = workWithNode,
          outerHTML = _workWithNode.outerHTML;
      ensureScriptWrapper(outerHTML, node).then(function () {
        return resolve(result);
      });
    }
  });
}

export { transformToOriginalAttribute };